<template>
  <div id="grid-centro">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <v-toolbar card color="white">
        <v-toolbar-title class="indigo--text">Centros</v-toolbar-title>
      </v-toolbar>
      <v-layout>
        <v-flex xs3 order-md4>
          <v-btn
            v-if="
              tabSelected == 'Acopio' &&
              (usuarioLoggedTipe == 'PROVEEDOR' ||
                usuarioLoggedTipe == 'ADMINISTRADOR')
            "
            depressed
            outline
            icon
            fab
            dark
            color="primary"
            medium
            title="Cargar planilla"
            @click="cargaMasivaAc()"
          >
            cargar
          </v-btn>
          <v-btn
            v-if="
              tabSelected == 'Operacion' &&
              (usuarioLoggedTipe == 'PROVEEDOR' ||
                usuarioLoggedTipe == 'ADMINISTRADOR')
            "
            depressed
            outline
            icon
            fab
            dark
            color="primary"
            medium
            title="Cargar planilla"
            @click="cargaMasivaOp()"
          >
            cargar
          </v-btn>
          <v-btn
            v-if="
              tabSelected == 'Capacitacion' &&
              (usuarioLoggedTipe == 'PROVEEDOR' ||
                usuarioLoggedTipe == 'ADMINISTRADOR')
            "
            depressed
            outline
            icon
            fab
            dark
            color="primary"
            medium
            title="Cargar planilla"
            @click="cargaMasivaCa()"
          >
            cargar
          </v-btn>
        </v-flex>
        <v-flex xs5 order-md3 grid-list-xl>
          <v-toolbar-title
            v-if="
              usuarioLoggedTipe == 'PROVEEDOR' ||
              usuarioLoggedTipe == 'ADMINISTRADOR'
            "
            class="indigo--text"
            >Carga masiva Centros</v-toolbar-title
          >
          <data-adjunto
            v-if="
              usuarioLoggedTipe == 'PROVEEDOR' ||
              usuarioLoggedTipe == 'ADMINISTRADOR'
            "
            :documentoId="id"
            :tipeView="tipeView"
            :tipeArchive="tipeArchive"
          >
          </data-adjunto>
        </v-flex>
        <v-flex xs3 order-md2 order-xs1>
          <v-btn
            v-if="
              usuarioLoggedTipe == 'PROVEEDOR' ||
              usuarioLoggedTipe == 'ADMINISTRADOR'
            "
            color="primary"
            @click="openCentro()"
          >
            Nuevo Centro</v-btn
          >
        </v-flex>
        <v-flex xs4 order-md1>
          <v-btn
            v-if="
              usuarioLoggedTipe == 'PROVEEDOR' ||
              usuarioLoggedTipe == 'ADMINISTRADOR'
            "
            color="primary"
            @click="descargaPlantilla()"
            >Descarga Plantilla Centros</v-btn
          >
        </v-flex>
      </v-layout>
      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-select
            v-model="regionValue"
            :items="regionSelect"
            label="Region"
            data-vv-name="listaRegiones"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="comunaValue"
            :items="comunaSelect"
            label="Comuna"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="estadoValue"
            :items="estadoSelect"
            label="Estado"
          ></v-select>
        </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="filterCenter()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <!-- BOTON NO INCLUIDO EN DISEÑO DEBERIA ESTAR -->
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsCentro"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.codCentro }}</td>
              <td class="text-xs-left">{{ props.item.region.nombre }}</td>
              <td class="text-xs-left">{{ props.item.comuna.nombre }}</td>
              <td class="text-xs-left">{{ props.item.direccion }}</td>
              <td class="text-xs-left">
                {{ props.item.estadoCentro.descripcion }}
              </td>
              <div class="text-xs-center">
                <td>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Consulta datos centro"
                    @click="viewCentro(props.item.id)"
                  >
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                  <!-- <v-btn                 
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="blue"
                    small
                    title="Consulta observaciones centro"
                    @click="viewObservacion(props.item.id)"
                  >
                    <v-icon>find_in_page</v-icon>
                  </v-btn> -->
                  <!-- <v-btn 
                    v-if="usuarioLoggedTipe=='AGENCIA' || usuarioLoggedTipe=='ADMINISTRADOR'"                
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                    title="Registra observaciones centro"
                    @click="editObservacion(props.item.id)"
                  >
                    <v-icon>open_in_new</v-icon>
                  </v-btn> -->
                  <v-btn
                    v-if="
                      usuarioLoggedTipe == 'PROVEEDOR' ||
                      usuarioLoggedTipe == 'ADMINISTRADOR'
                    "
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="light-green"
                    small
                    title="Modifica datos centro"
                    @click="editCentro(props.item.id)"
                  >
                    <v-icon>assignment</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      usuarioLoggedTipe == 'AGENCIA' ||
                      usuarioLoggedTipe == 'ADMINISTRADOR'
                    "
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="blue"
                    small
                    title="Validacion de Centro"
                    @click="validaCentro(props.item.id)"
                  >
                    <v-icon>find_in_page</v-icon>
                  </v-btn>
                </td>
              </div>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA PROVEEDORES -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template>
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                  >
                    <v-icon>remove_red_eye</v-icon> </v-btn
                  >Consulta datos centro
                </template>
                <template>
                  <v-btn
                    v-if="
                      usuarioLoggedTipe == 'AGENCIA' ||
                      usuarioLoggedTipe == 'ADMINISTRADOR'
                    "
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="blue"
                    small
                  >
                    <v-icon>find_in_page</v-icon> </v-btn
                  >Validacion
                </template>
                <!-- <template v-if="usuarioLoggedTipe=='AGENCIA' || usuarioLoggedTipe=='ADMINISTRADOR'" >
                    <v-btn                       
                      class="btn-sigas"
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="primary"
                      small
                    >
                      <v-icon>open_in_new</v-icon>
                    </v-btn>Registra observaciones centro
                  </template> -->
                <template
                  v-if="
                    usuarioLoggedTipe == 'PROVEEDOR' ||
                    usuarioLoggedTipe == 'ADMINISTRADOR'
                  "
                >
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="light-green"
                    small
                  >
                    <v-icon>assignment</v-icon> </v-btn
                  >Modifica datos centro
                </template>
              </td>
            </div>
          </v-card-actions>
          <!--fin iconos leyenda-->
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialogLoading" persistent max-width="390">
      <loading-descarga></loading-descarga>
    </v-dialog>
    <!-- DIALOGO DE ACEPTAR O RECHAZAR ACUERDO -->
    <template>
      <v-dialog v-model="dialog" persistent max-width="490">
        <v-card>
          <v-card-title class="headline"
            >Aceptar/Rechazar/Observar Centro</v-card-title
          >
          <v-card-text>
            <p>
              <b>Seleccione una de las siguientes opciones:</b><br /><br />
              - Si <b>Acepta</b>, se aprobara el centro previsto.<br />
              - Si <b>Rechaza</b>,se rechazara el centro previsto. Favor indicar
              motivo de estado<br />
              - Si <b>Observa</b>,se observara el centro previsto. Favor indicar
              motivo de estado<br /><br />
            </p>

            <p>
              <b>Ingrese sus obseravaciones si lo requiere:</b><br /><br />

              <v-textarea
                v-model="observacion"
                label="Observaciones"
              ></v-textarea>
              <br />
              <b>Cancele</b> si no se encuentra segura/o.<br /></p
          ></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" flat @click="dialog = false">Cancelar</v-btn>
            <v-btn color="yellow darken-1" flat @click="actualizarEstado('O')"
              >Observar</v-btn
            >
            <v-btn color="red darken-1" flat @click="actualizarEstado('R')"
              >Rechazar</v-btn
            >
            <v-btn color="green darken-1" flat @click="actualizarEstado('A')"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <!-- DIALOGO DE ACEPTAR O RECHAZAR ACUERDO -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import DataAdjunto from "@/components/AdjuntoData.vue";
import { misMixins } from "@/mixins/myMixing.js";
export default {
  name: "grid-centro",
  components: {
    Loading,
    DataAdjunto,
    LoadingDescarga,
  },
  mixins: [misMixins],
  props: {
    rowsTable: "",
  },

  data() {
    return {
      loading: false,
      observacion: "",
      dialog: false,
      idEstado: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      contratoId: "",
      itemsProgreso: [],
      headers: [
        {
          text: "Cod-Centro",
          align: "left",
          sortable: false,
          value: "codCentro",
        },
        { text: "Region", sortable: false, value: "region" },
        { text: "Comuna", sortable: false, value: "comuna" },
        { text: "Direccion", sortable: false, value: "direccion" },
        { text: "Estado", sortable: false, value: "estado" },
        {
          text: "Accion",
          sortable: false,
          value: "accion",
        },
      ],
      fechaInicioValue: [],
      usuarioLoggedTipe: "",
      bloqueo: Boolean,
      itemsCentro: [],
      regionValue: null,
      regionSelect: [],
      comunaValue: null,
      comunaSelect: [],
      estadoValue: null,
      estadoSelect: [],
      filter: false,
      dialogLoading: false,
      idCentro: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;
      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  created() {
    this.loading = true;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.tabSelected = this.$store.getters.subTabSelectedStored;
    this.loadData();
  },

  mounted() {},
  computed: {},
  methods: {
    validaCentro(id) {
      this.dialog = true;
      this.idCentro = id;
    },

    actualizarEstado(estado) {
      let idContrato = this.$store.getters.contratoStored;
      if (estado == "A") {
        this.body = {
          // -----
          contrato: idContrato,
          estado: "APROBADO",
        };
      }
      if (estado == "R") {
        this.body = {
          // -----
          contrato: idContrato,
          estado: "REPROBADO",
          observaciones: this.observacion,
        };
      }
      if (estado == "O") {
        this.body = {
          // -----
          contrato: idContrato,
          estado: "OBSERVADO",
          observaciones: this.observacion,
        };
      }

      axios
        .put("/centro/update/" + this.idCentro, this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_SAVE");
          this.cerrarModal();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
        });
    },
    cerrarModal() {
      this.dialog = false;
      this.reload();
    },

    reload() {
      this.$parent.$parent.reloadDocumento();
    },

    descargaPlantilla() {
      this.dialogLoading = true;
      axios
        .get(
          "/centro/downloadPlantilla/" +
            this.idContrato +
            "/" +
            this.tabSelected,
          { responseType: "blob" }
        )
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "PLANILLA_CENTRO.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    cargaMasivaAc() {
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        documento: base64EncodedStr,
        contrato: idContrato,
      };
      axios
        .post("/centro/acopio/cargaMasiva", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.reload();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.reload();
          }
        });
    },
    cargaMasivaOp() {
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        documento: base64EncodedStr,
        contrato: idContrato,
      };
      axios
        .post("/centro/operacion/cargaMasiva", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.reload();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.reload();
          }
        });
    },
    cargaMasivaCa() {
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        documento: base64EncodedStr,
        contrato: idContrato,
      };
      axios
        .post("/centro/capacitacion/cargaMasiva", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.reload();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.reload();
          }
        });
    },

    openCentro() {
      setTimeout(() => {
        this.$router.push({
          name: "FormCentroAp",
          params: { tipeView: "crear", titleViewCenter: "Nuevo Centro" },
        });
      }, 1000);
    },

    viewCentro(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormCentroAp",
          params: {
            idCentro: id,
            tipeView: "consulta",
            titleViewCenter: "Consulta de Centro",
          },
        });
      }, 1000);
    },

    editCentro(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormCentroAp",
          params: {
            idCentro: id,
            tipeView: "modifica",
            titleViewCenter: "Edicion de Centro",
          },
        });
      }, 1000);
    },

    viewObservacion(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormObservacion",
          params: { idCentro: id, tipeView: "consulta" },
        });
      }, 1000);
    },
    editObservacion(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormObservacion",
          params: { idCentro: id, tipeView: "modifica" },
        });
      }, 1000);
    },

    async loadCentrosFilter() {
      let that = this;
      let subTab = this.$store.getters.subTabSelectedStored;
      let proceso = this.$store.getters.proSelectedStored;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        region:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        comuna:
          this.comunaValue && this.comunaValue != null
            ? this.comunaValue
            : null,
        estadoCentro:
          this.estadoValue && this.estadoValue != null
            ? this.estadoValue
            : null,

        proceso: proceso,
        idContrato: idContrato,
        tipoCentro: {
          descripcion: subTab,
        },
      };
      return await axios

        .post("/centro/filters", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },

    async loadData() {
      this.loading = true;
      this.itemsCentro = await this.loadCentrosFilter();
      this.loading = false;
      if (this.itemsCentro.length > 0) {
        this.loadRegionSelect();
        this.loadComunaSelect();
        this.loadEstadoSelect();
      }
    },

    loadRegionSelect() {
      let reg = [];
      this.itemsCentro.forEach(function (c) {
        let index = reg.findIndex((x) => x.region == c.region.nombre);
        if (index === -1) {
          reg.push(c.region.nombre);
        }
      });
      this.regionSelect = reg;
    },

    loadComunaSelect() {
      let com = [];
      this.itemsCentro.forEach(function (c) {
        let index = com.findIndex((x) => x.comuna == c.comuna.nombre);
        if (index === -1) {
          com.push(c.comuna.nombre);
        }
      });
      this.comunaSelect = com;
    },
    loadEstadoSelect() {
      let est = [];
      this.itemsCentro.forEach(function (c) {
        let index = est.findIndex(
          (x) => x.estadoCentro == c.estadoCentro.descripcion
        );
        if (index === -1) {
          est.push(c.estadoCentro.descripcion);
        }
      });
      this.estadoSelect = est;
    },

    clear() {
      this.regionValue = "";
      this.comunaValue = "";
      this.estadoValue = "";
      this.loadData();
    },
    //SOLO NUMEROS
    bloqueoEdicion(tip) {
      if (tip == "AGENCIA") {
        this.bloqueo = true;
      }
      if (tip == "PROVEEDOR") {
        this.bloqueo = false;
      }
      return this.bloqueo;
    },

    filterCenter() {
      this.filter = true;
      this.loadData();
    },
  },
};
</script>
